// @core/api/endpoints/workflow/list_pipeline_policies.ts
// Auto-generated by corebuilder. DO NOT EDIT.

import { getApiClient, type RequestOptions } from '../../client';
import type {
  ListPipelinePoliciesResponse,
} from '../../../types/workflow';
import type { PaginatedRequest } from '../../../types/pagination';

const BASE_PATH = '/workflow';

/**
 * List pipeline policies
 * Returns pipeline policies, optionally filtered by scope entity type.
 */
export async function ListPipelinePolicies(
  params?: PaginatedRequest,
  options?: RequestOptions
): Promise<ListPipelinePoliciesResponse> {
  const client = getApiClient();
  const requestPath = `${BASE_PATH}/pipeline-policies`;
  const requestOptions = options;
  return client.get<ListPipelinePoliciesResponse>(requestPath, { ...requestOptions, params });
}
